import { Component, Input, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { LibraryInjectorService } from 'angular-engine/engine/service/util/';
import { Lightbox } from 'ngx-lightbox';

@Component({
    selector: 'gallery-row',
    templateUrl: 'gallery-row.template.html',
    styleUrls: ['gallery-row.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GalleryRow {
    @Input() row$: any;
    @ViewChild('galleryRow') galleryRow: ElementRef;

    private _gallery: Array<any> = [];

    constructor(
        private _librayService: LibraryInjectorService,
        private _lightbox: Lightbox
    ) { }

    ngAfterViewInit() {
        if (this.row$) {
            let masonry = this._librayService.getClientLibrary('masonry-layout');
            let imagesLoaded = this._librayService.getClientLibrary('imagesLoaded')

            let msnry = new masonry(this.galleryRow.nativeElement, {
                // options
                itemSelector: '.gallery-item',
                gutter: '.gutter-sizer',
                percentPosition: true,
            });

            imagesLoaded(this.galleryRow.nativeElement, () => {
                msnry.layout();
            });

            this._gallery = this.row$.data.map((item) => {
                const meta = typeof item.meta !== "undefined" ? item.meta : item;
                return { src: meta.images[0].url, caption: `${meta.title} • ${meta.summary}`, thumb: "" }
            });
        }
    }

    private open(index: number, _event: any): void {
        if (this._gallery.length > 0) {
            this._lightbox.open(this._gallery, index);
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/gallery/gallery-row/gallery-row.component.ts